module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file_upload_input",
    style: ({
      width: _vm.c_wid + 'px'
    }),
    on: {
      "change": _vm.upload
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.words))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.BtnText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d4f7dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input_file.vue
// module id = 824
// module chunks = 1